import {useCallback} from 'react';
import useTracking from '@src/Tracking/useTracking';
import {TraceTokEvents} from '@src/Tracking/catalog';

/**
 * Canonical cta_clicked emitter. Keeps the legacy call shape
 * ({type, name, section, page, blockType, blockName}) so existing call sites
 * only need to swap the function, and maps it to the canonical event once here.
 */
export interface CtaClickProps {
  type: string;
  name: string;
  section?: string;
  page?: string;
  blockType?: string;
  blockName?: string;
}

export const useTrackCta = () => {
  const {emit} = useTracking();
  return useCallback(
    (p: CtaClickProps) =>
      emit(TraceTokEvents.CTAClicked, {
        cta_id: p.name,
        cta_name: p.name,
        cta_type: p.type,
        cta_section: p.section,
        cta_page: p.page,
        cta_block_type: p.blockType,
        cta_block_name: p.blockName,
      }),
    [emit],
  );
};

export default useTrackCta;
